import { Input, Popover, Select } from 'antd';
import { Form } from '@ant-design/compatible';
import React from 'react';
const validator = require('validator');

//THIS FILE EXISTS SEPARATELY DUE TO THE CHANGES IN ANTD FORM ITEMS, EVENTUALLY IT SHOULD BE PHASED OUT

export default function EmailComponentAntdV3({
	form,
	formData,
	label,
	fieldProps,
	placeholder = 'Enter email',
	...props
}) {
	const emailValidator = (rule, value, callback) => {
		if (!value) {
			callback();
		} else {
			if (validator.isEmail(value)) {
				callback();
			} else {
				callback(value + ' is not a valid email');
			}
		}
	};
	return (
		<Form.Item label={label} style={{ display: 'block' }}>
			{form.getFieldDecorator(fieldProps.name, {
				...fieldProps,
				rules: [...(fieldProps.rules || []), { validator: emailValidator }],
				initialValue: formData[fieldProps.name],
			})(<Input placeholder={placeholder} {...props} />)}
		</Form.Item>
	);
}
